import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TipoDanno } from 'src/app/models/tipo-danno';
import { BaseEditForm } from 'src/app/shared/baseEditForm';


@Component({
  selector: 'tipi-danno-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class TipiDannoFormComponent extends BaseEditForm implements OnInit {

  tipoDanno: TipoDanno;
  form: FormGroup;
  constructor(private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<TipiDannoFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: TipoDanno,) {
    super();
    this.tipoDanno = data;
  }

  ngOnInit() {

    this.form = this.fb.group({
      nome: [this.tipoDanno?.nome, Validators.required],
      gruppo_tipi_danno: [this.tipoDanno?.gruppo_tipi_danno, Validators.required],
    });
  }

}

